

























































































































































































import settings from '@/settings'
import n from '@/utils/notifications'
import q from '@/graphql/query'
import m from '@/graphql/mutation'
import t from '@/utils/tools'
import af from '@/utils/authorized_formats'

export default {
    name: 'company_interviews_campaigns'

    data: ()->
        errors: {}
        loading: true
        alert: false
        search: ''
        pager_count: 5
        current_page: 1
        page_size: 10
        active_names: [1]
        false: false
        readonly: false
        picker_options: {firstDayOfWeek:1}
        campaign_type_choice_set: [
            {value:0, label:'Professionnels et d\'évaluation'}
            {value:1, label:'Annuels'}
        ]
        user_doc_max_filesize: af['interview_campaign']['user_doc']['max_filesize']/1024/1024
        manager_doc_max_filesize: af['interview_campaign']['manager_doc']['max_filesize']/1024/1024
        manager_final_doc_max_filesize: af['interview_campaign']['manager_final_doc']['max_filesize']/1024/1024
        user_doc_authorized_formats: af['interview_campaign']['user_doc']['authorized_formats']
        manager_doc_authorized_formats: af['interview_campaign']['manager_doc']['authorized_formats']
        manager_final_doc_authorized_formats: af['interview_campaign']['manager_final_doc']['authorized_formats']
        sizes: []
        campaign: {
            uid: ''
            name: ''
            start: ''
            end: ''
            campaign_type: 0
            user_doc_data: ''
            user_doc_name: ''
            manager_doc_data: ''
            manager_doc_name: ''
            manager_final_doc_data: ''
            manager_final_doc_name: ''
            complete_filename: ''
            user_doc: ''
            user_doc_dir: ''
            manager_doc: ''
            manager_doc_dir: ''
            manager_final_doc: ''
            manager_final_doc_dir: ''
        }
        selected_user_uid: ''
        campaigns: []
        managers: []

    computed:
        data_filtered: ()->
            self = @
            data = @campaigns.filter (x) ->
                campaign_type_label = self.get_label(x.campaign_type)
                start_date = self.date_formatter(x.start)
                end_date = self.date_formatter(x.end)
                user_str = x.user.user_info.firstname+" "+x.user.user_info.lastname

                !self.search || x.name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || x.name.toLowerCase().includes(self.search.toLowerCase())\
                || campaign_type_label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || campaign_type_label.toLowerCase().includes(self.search.toLowerCase())\
                || start_date.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || start_date.toLowerCase().includes(self.search.toLowerCase())\
                || end_date.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || end_date.toLowerCase().includes(self.search.toLowerCase())\
                || user_str.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || user_str.toLowerCase().includes(self.search.toLowerCase())
            return data

        data_paged: ()->
            data = @data_filtered.slice(((@current_page - 1) * @page_size), (@page_size * @current_page))
            return data

        save_text: ()->
            text = "Ajouter"
            if @campaign.uid != ''
                text = "Enregistrer"
            return text

        toggle_collapse_text: ()->
            text = "Ajouter une campagne d'entretiens"
            if @active_names.length > 1
                text = "Fermer"
            return text

        toggle_collapse_icon: ()->
            class_icon = 'mdi-plus-circle-o'
            if @active_names.length > 1
                class_icon = 'mdi-close-circle-o'
            return class_icon

        user_is_admin: ()->
            return @$store.state.user_datas.profiles.indexOf('distributor') != -1 or @$store.state.user_datas.profiles.indexOf('superadmin') != -1

    methods:
        date_formatter: t.date_formatter

        listen_sort: ({ column, prop, order })->
            # console.log "LISTEN", column, prop, order
            self = @
            @campaigns.sort (a,b)->
                modifier = 1
                field_a = a[prop]
                field_b = b[prop]
                if prop == 'campaign_type'
                    field_a = self.get_label(a[prop])
                    field_b = self.get_label(b[prop])
                else if prop == 'user'
                    field_a = a[prop]['user_info']['firstname']+" "+a[prop]['user_info']['lastname']
                    field_b = b[prop]['user_info']['firstname']+" "+b[prop]['user_info']['lastname']
                if order == 'descending'
                    modifier = -1
                return field_a.toLowerCase().localeCompare(field_b.toLowerCase())*modifier

        handle_size_change: (val)->
            @page_size = val

        handle_current_change: (val)->
            @current_page = val

        get_title: (campaign_type, doc)->
            return af['interview_campaign'][doc]['title'][campaign_type]

        get_label: (value)->
            for c in @campaign_type_choice_set
                if c.value == value
                    return c.label

        get_errors: (fieldName)->
            ret = null
            if @errors[fieldName]?
                ret = @errors[fieldName][0]
            return ret

        reset_campaign: ()->
            @campaign = {
                uid: ''
                name: ''
                start: ''
                end: ''
                campaign_type: 0
                user_doc_data: ''
                user_doc_name: ''
                manager_doc_data: ''
                manager_doc_name: ''
                manager_final_doc_data: ''
                manager_final_doc_name: ''
                complete_filename: ''
                user_doc: ''
                user_doc_dir: ''
                manager_doc: ''
                manager_doc_dir: ''
                manager_final_doc: ''
                manager_final_doc_dir: ''
            }
            @selected_user_uid = ''

        collapse_change: (value)->
            # console.log "VUE TOGGLE ", value
            @errors = {}
            @reset_campaign()
            if @$refs.user_doc_upload?
                @$refs.user_doc_upload.clearFiles()
            if @$refs.manager_doc_upload?
                @$refs.manager_doc_upload.clearFiles()
            if @$refs.manager_final_doc_upload?
                @$refs.manager_final_doc_upload.clearFiles()
            return

        handle_tmp_file_remove: (file, fileList, doc)->
            # console.log "HANDLE TMP FILE REMOVE", file, fileList, doc
            @$refs[doc+'_doc_upload'].clearFiles()
            @campaign[doc+'_doc_data'] = ''
            @campaign[doc+'_doc_name'] = ''
            return

        handle_file_remove: (doc)->
            @campaign[doc+'_doc'] = ''
            @campaign[doc+'_doc_dir'] = ''
            return

        handle_file_change: (file, fileList, doc)->
            is_good_ext = file.raw.type in af['interview_campaign'][doc+'_doc']['mime_types']
            is_good_size = file.size < af['interview_campaign'][doc+'_doc']['max_filesize']

            if !is_good_ext
                n.file_error('Erreur', 'Le fichier doit être de type '+@[doc+'_doc_authorized_formats']+'.')
                fileList.pop()
                return

            if !is_good_size
                n.file_error('Erreur', 'Le fichier ne peut excéder pas '+@[doc+'_doc_max_filesize']+'Mo.')
                fileList.pop()
                return

            self = @
            if fileList.length > 1
                fileList.splice(0,1)
            reader = new FileReader()
            reader.onload = (e)->
                # console.log 'E', e
                self.campaign[doc+'_doc_data'] = e.target.result
                self.campaign[doc+'_doc_name'] = file.name
            reader.readAsDataURL(file.raw)
            # console.log "FILE", @campaign
            return

        user_tmp_file_remove: (file, fileList)->
            @handle_tmp_file_remove(file, fileList, 'user')
            return

        manager_tmp_file_remove: (file, fileList)->
            @handle_tmp_file_remove(file, fileList, 'manager')
            return

        manager_final_tmp_file_remove: (file, fileList)->
            @handle_tmp_file_remove(file, fileList, 'manager_final')
            return

        user_file_change: (file, fileList)->
            @handle_file_change(file, fileList, 'user')
            return

        manager_file_change: (file, fileList)->
            @handle_file_change(file, fileList, 'manager')
            return

        manager_final_file_change: (file, fileList)->
            @handle_file_change(file, fileList, 'manager_final')
            return

        get_filename: (campaign, index)->
            # console.log "GET FILENAME", campaign
            names_array = campaign.complete_filename.split(',')
            return names_array[index]

        download_file: (campaign, doc, index)->
            url = settings.media_url+campaign[doc+'_dir']+'/'+campaign[doc]
            filename = @get_filename(campaign, index)
            t.download_file(url, filename)
            return

        edit_campaign: (campaign)->
            @campaign = t.deep_copy(campaign)
            # console.log "EDIT CAMPAIGN", @campaign
            if @user_is_admin
                @selected_user_uid = campaign.user.uid
            @active_names = [1, "1"]
            @$root.$el.scrollTop = 0
            return

        delete_campaign: (campaign_uid)->
            self = @
            @$confirm("Êtes-vous sûr·e de vouloir supprimer cette campagne d'entretiens ?", 'Confirmation', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler'
                })
                .then ()->
                    m.run('delete_object', ['interview_campaign', campaign_uid])
                    .then (resp)->
                        if resp.body.data.interview_campaign_deletion.ok
                            n.success()
                            self.get_campaigns()
                        else
                            n.gql_error("company_interviews_campaigns: delete_campaign: then", resp.body.data.interview_campaign_deletion.message)
                    .catch (resp)->
                        n.catch_error(resp, "company_interviews_campaigns: delete_campaign()")
                .catch (cancel)->
                    return

        save: ()->
            self = @
            if @user_is_admin and @selected_user_uid == ''
                n.warning("Vous devez associer un utilisateur à cette campagne.")
                return
            m.run('save_campaign', [@campaign, @selected_user_uid])
            .then (resp)->
                if resp.body.data.interview_campaign_form_mutation.form_ret == 'failed'
                    return n.access_denied()
                if resp.body.data.interview_campaign_form_mutation.errors.length > 0
                    self.errors = resp.body.data.interview_campaign_form_mutation.errors.reduce(
                        (acc, el)->
                            acc[el.field] = el.messages
                            return acc
                    ,{})
                    n.form_error()
                else
                    self.errors = {}
                    n.success()
                    self.reset_campaign()
                    if self.$refs.user_doc_upload?
                        self.$refs.user_doc_upload.clearFiles()
                    if self.$refs.manager_doc_upload?
                        self.$refs.manager_doc_upload.clearFiles()
                    if self.$refs.manager_final_doc_upload?
                        self.$refs.manager_final_doc_upload.clearFiles()
                    self.active_names = [1]
                    self.get_campaigns()
            .catch (resp)->
                n.catch_error(resp, "company_interviews_campaigns: save()")

        get_managers: ()->
            self = @
            # console.log "GET MANAGERS ", @$store.getters.current_company.uid
            q.run('get_manager_set', [@$store.getters.current_company.uid, @$store.state.user_datas.app_user.uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("company_interviews_campaigns: get_managers: then", e.message)
                else
                    # console.log "GET MANAGERS : ", resp.body.data.manager_set
                    self.managers = resp.body.data.manager_set
            .catch (resp)->
                n.catch_error(resp, "company_interviews_campaigns: get_managers()")

        get_campaigns: ()->
            self = @
            @loading = true
            q.run('get_campaign_set', [@$store.getters.current_company.uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("company_interviews_campaigns: get_campaigns: then", e.message)
                else
                    # console.log "GET CAMPAIGNS : ", resp.body.data.interview_campaign_set
                    self.campaigns = resp.body.data.interview_campaign_set
                    self.loading = false
                    if self.campaigns.length == 0
                        self.alert = true
                    else
                        self.alert = false
            .catch (resp)->
                n.catch_error(resp, "company_interviews_campaigns: get_campaigns()")
            
    beforeMount: ()->
        @get_campaigns()
        if @user_is_admin
            @get_managers()
}
